import React from 'react';
import { FormattedMessage } from 'react-intl';

import styles from './styles.css';

const CommboxOmTrigger = ({ onClick }: { onClick: () => void }) => (
  <button
    className={styles.commboxInput}
    onClick={onClick}
    data-testid="commboxTrigger"
  >
    <div className={styles.textInput}>
      <FormattedMessage id="COMMBOX_EMPTY_TEXT_FIELD" />
    </div>
  </button>
);

export { CommboxOmTrigger };
